/**
 * GA4 connect for a granted client (connectors module, flag connectors.ga4 on the client; 404 while off or without an
 * active grant carrying manage:campaigns). Agency owners / admins only.
 */
import type { Ga4AgencyCallbackResult, Ga4AgencyConnectionView } from '@qm/contracts/connectors-ga4';
import { seg, type Http } from '../kit/http';

export function ga4ConnectApi(http: Http) {
  const client = (tenantId: string) => `/v1/connectors/agency/clients/${seg(tenantId)}/ga4` as const;
  return {
    connections: (tenantId: string) => http.get<Ga4AgencyConnectionView[]>(`${client(tenantId)}/connections`),
    start: (tenantId: string, reconnectConnectionId?: string) =>
      http.post<{ authorizeUrl: string; state: string }>(`${client(tenantId)}/oauth/start`, reconnectConnectionId ? { reconnectConnectionId } : {}),
    callback: (state: string, code: string) => http.post<Ga4AgencyCallbackResult>('/v1/connectors/agency/ga4/oauth/callback', { state, code }),
    select: (pendingId: string, accountRefs: string[]) =>
      http.post<{ tenantId: string; connections: Ga4AgencyConnectionView[] }>('/v1/connectors/agency/ga4/oauth/select', { pendingId, accountRefs }),
    disconnect: (tenantId: string, id: string) => http.post<{ id: string; status: string }>(`${client(tenantId)}/connections/${seg(id)}/disconnect`, {}),
  };
}
